import {
    updateHeaderShoppingBagCounts
} from '../international/_intl';

import Cookies from 'js-cookie';


var cachedCookie = Cookies.get('301_CVMINICART'),
    cachedHTML = "";

const retrieveMiniCart = (caller) => {
    var split1 = "",
        split2 = "",
        split3 = "",
        itemCountInCookie = "",
        priceInCookie = "",
        itemCountOnStickyBar = $('#myDillardsBagCount').text(),
        price = $('#myDillardsBagPrice').text(),
        priceDisplay = price.split('$'),
        priceOnStickyBar = priceDisplay[1],
        noItems = "items~~~0@amount~~~0.00@",
        a = "a",
        miniCartCookie = Cookies.get('301_CVMINICART');

    if (miniCartCookie !== "" && miniCartCookie !== undefined && miniCartCookie !== null && miniCartCookie !== a && miniCartCookie !== noItems) {
        split1 = miniCartCookie.split('@');
        split2 = split1[0].split('~~~');
        split3 = split1[1].split('~~~');
        itemCountInCookie = split2[1];
        priceInCookie = split3[1];
    } else {
        itemCountInCookie = "0";
        priceInCookie = "0.00";
    }

    if ((itemCountInCookie !== itemCountOnStickyBar && priceInCookie !== priceOnStickyBar) || cachedHTML == "" || caller == "MyDillardsShoppingBag" || cachedCookie != Cookies.get('301_CVMINICART')) {
        $.ajax({
            type: 'POST',
            cache: false,
            url: "/webapp/wcs/stores/servlet/MiniCartPopoutCmd",
            data: "storeId=301&langId=-1&catalogId=301&caller=" + caller,
            success: function(html) {
                var emptyMessage = $(html).hasClass('emptyMessage');
                if (caller == "ShoppingBag") {
                    if (emptyMessage) {
                        $("#miniShoppingCart").html("");
                        $("#miniShoppingCart").hide();
                        $('.myDillardsShoppingBag').removeClass('shoppingCartArrow');
                        $("#miniShoppingCart").removeClass('visible');
                    } else if (!emptyMessage) $("#miniShoppingCart").html(html);
                    cachedHTML = html;
                    cachedCookie = Cookies.get('301_CVMINICART');
                } else $("#myDillardsDropdownDynamic").html(html);
                updateHeaderShoppingBagCounts();
            }
        });
    } else {
        var html = cachedHTML,
            emptyMessage = $(html).hasClass('emptyMessage');
        if (caller == "ShoppingBag") {
            if (!emptyMessage) {
                $("#miniShoppingCart").fadeIn('fast');
                $("#miniShoppingCart").addClass('visible');
                $('.myDillardsShoppingBag').addClass('shoppingCartArrow');
            }
            $("#miniShoppingCart").html(html);
            cachedHTML = html;
        } else $("#myDillardsDropdownDynamic").html(html);
        updateHeaderShoppingBagCounts();
    }
};

export {
    retrieveMiniCart
}
